import { defineStore } from 'pinia';

export const useGroupAdminStore = defineStore('groupAdmin', {
    state: () => ({
        groupAdminId: null,
        groupIds: [],
    }),

    getters: {
        hasUser: (state) => !!state.groupAdminId,
    },

    actions: {
        setUser({ group_admin_id: groupAdminId, groups }) {
            this.groupAdminId = groupAdminId;
            this.groupIds = groups ? Object.keys(groups) : [];
        },
    },
});
